import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { z } from 'zod';
import { PasswordPage } from '@/features/auth/password-page';
import { meQuery } from '@/lib/auth/session';
import { safeRedirect } from './login';

// ADR 0059: «Scegli una nuova password» after an invitation's temporary
// password; without a session → the login, without the flag → the app.
export const Route = createFileRoute('/password')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  beforeLoad: async ({ context, search }) => {
    const user = await context.queryClient.ensureQueryData(meQuery).catch(() => null);
    if (!user) throw redirect({ to: '/login' });
    if (!user.must_change_password) throw redirect({ href: safeRedirect(search.redirect) });
    return { user };
  },
  component: ChangePassword,
});

function ChangePassword() {
  const search = Route.useSearch();
  const { user } = Route.useRouteContext();
  const router = useRouter();
  return (
    <PasswordPage
      name={user.name.split(/\s+/)[0] ?? user.name}
      onChanged={() => {
        void router.navigate({ href: safeRedirect(search.redirect), replace: true });
      }}
      onSignedOut={() => {
        void router.navigate({ to: '/login', replace: true });
      }}
    />
  );
}
